import React, { PureComponent } from "react";
import { BarChart, ReferenceLine, Bar, Cell, XAxis, YAxis, Tooltip } from "recharts";

import styles from "./style.module.css";

export default class TinyBarChart extends PureComponent {
  render() {
    const { bars, unit, label, warning } = this.props;

    if (bars === undefined) {
      return <div />;
    }

    let lowX = bars.reduce((min, b) => (parseInt(b[label]) < min ? parseInt(b[label]) : min), 0);

    return (
      <div className={styles.barChart}>
        <BarChart
          width={320}
          height={260}
          data={bars}
          layout={"vertical"}
          margin={{ top: 0, right: 20, bottom: 10, left: 30 }}
        >
          <XAxis dataKey={label} type={"number"} hide unit={unit} />
          <ReferenceLine x={0} stroke="#000" />
          <YAxis dataKey={"label"} type={"category"} />
          <Tooltip formatter={(value, name, props) => value + unit} />
          <Bar dataKey={label}>
            {bars.map((p, index) => (
              <Cell key={index} fill={p[label] > 0 ? "#5BCF74" : "#C03E5A"} />
            ))}
          </Bar>
        </BarChart>
      </div>
    );
  }
}
